import {
  expectedPaxTypeForSlot,
  normalizeExplicitPaxType,
} from "./derivePaxTypeFromAgeOrSelection";

/**
 * Detects passengers whose declared internalPaxType / paxType / pax_type
 * disagrees with their room-array slot (adults / kids / infants).
 * Use before save if you want to block or show UI errors; preparePassengersInfoForLdsSave normalizes to slot.
 *
 * @param {unknown} roomsAndPaxInfo
 * @returns {Array<{ roomIndex: number, slot: string, passengerIndex: number, refId: unknown, declared: string, expected: string }>}
 */
export function findPassengerSlotTypeMismatches(roomsAndPaxInfo) {
  const issues = [];
  if (!Array.isArray(roomsAndPaxInfo)) return issues;

  const scan = (room, roomIndex, list, slot) => {
    (list || []).forEach((pax, passengerIndex) => {
      if (!pax || typeof pax !== "object") return;
      const raw = pax.internalPaxType ?? pax.paxType ?? pax.pax_type;
      const declared = normalizeExplicitPaxType(raw);
      if (!declared) return;
      const expected = expectedPaxTypeForSlot(slot);
      if (declared !== expected) {
        issues.push({
          roomIndex,
          slot,
          passengerIndex,
          refId: pax["@seqNum"],
          declared,
          expected,
        });
      }
    });
  };

  roomsAndPaxInfo.forEach((room, roomIndex) => {
    if (!room || typeof room !== "object") return;
    scan(room, roomIndex, room.adults, "adults");
    scan(room, roomIndex, room.kids, "kids");
    scan(room, roomIndex, room.infants, "infants");
  });
  return issues;
}

/**
 * @returns {boolean}
 */
export function hasPassengerSlotTypeMismatches(roomsAndPaxInfo) {
  return findPassengerSlotTypeMismatches(roomsAndPaxInfo).length > 0;
}
